module.exports = __webpack_public_path__ + "img/icon-meteo-4@2x.fcf466a9.png";